import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=5195c2f5&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"
import style0 from "./Shop.vue?vue&type=style&index=0&id=5195c2f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-load_59134872458b6bd26a10c07340e882cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195c2f5",
  null
  
)

export default component.exports